import "../AddonInformationComponent.css"
import {Trans, useTranslation} from "react-i18next";
import {Button} from "@mui/material";
import CmsHelper, {PickProgramPageHelper} from "../../../../../Utilities/CmsHelpers";
import {useCms} from "../../../../../../context/CmsContext";
import React from "react";
import AddonComponent from "./AddonComponent";
import {useNavigate} from "react-router-dom";

export default function EligibleAddonsComponent({addon}) {
    const navigate = useNavigate();
    const {pickProgramData} = useCms();
    const { t } = useTranslation();

    const pickAddons = PickProgramPageHelper.getPickAddons(PickProgramPageHelper.getPrograms(pickProgramData, CmsHelper.DEFAULT))?.addons;
    const cmsData = PickProgramPageHelper.getAddon(pickAddons, addon?.skuORQuickCode)[0]
    if(!cmsData) return <></>

    const Status = ({className}) => (
        <span className={className} style={{color: "#FFFFFF"}}>
            {t("account-addon-inactive")}
        </span>
    );
    const Information = () => (
        <span className={"addon-description"}>
            {cmsData?.description}
        </span>
    )
    const PrimaryCta = () => (
        <div className={"addon-cta"}>
            <Button variant={"text"}
                    color={"primary"}
                    onClick={()=>{
                        navigate("/PickAddon")
                    }}>
                {<Trans i18nKey="accountAddonPrimaryCtaInactive"
                        values={{addon: cmsData?.title}}
                        tOptions={{interpolation: {escapeValue: false}}}
                />}
            </Button>
        </div>
    )
    const CancelSubscriptionCta = () => (
        <div className={"price-wrapper"}>
            <span className={"before-price"}>{cmsData?.beforePrice}</span><span
            className={"after-price"}>{cmsData?.afterPrice}</span>
        </div>
    )

    return <AddonComponent addon={cmsData?.title} Status={Status}
                           Information={Information} PrimaryCta={PrimaryCta}
                           CancelSubscriptionCta={CancelSubscriptionCta}/>
}